(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var messages = __pewniaki_inline_cfg[__pewniaki_inline_cfg.length - 1];
    function message(key, values) { return messages[key].replace(/%(\d+)/g, function (_, n) { return String(values[Number(n) - 1]); }); }
    var A = {
        en:      JSON.parse(String(__pewniaki_inline_cfg[0])),
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[1] + '/analizy/model.json',
        wersja: __pewniaki_inline_cfg[2],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[3] + '/lata/',
        kod:    __pewniaki_inline_cfg[4],
        pula:   __pewniaki_inline_cfg[5],
        typuje: __pewniaki_inline_cfg[6],
        _zadanie: 0,
        _pobranie: null,
        // Wkłady z surowych trafień; brak wpisu = liczba nie padła w zakresie.
        licz: function (liczby, N, m, kk) {
            var p = kk / m, E = N * p, SD = Math.sqrt(N * p * (1 - p)), kor = (m - 1) / m;
            var w = [], T = 0, maxZ = null;
            for (var n = 1; n <= m; n++) {
                var h = liczby[n] && liczby[n].hits != null ? +liczby[n].hits : 0;
                var z = SD > 0 ? (h - E) / SD : null, wk = z == null ? 0 : z * z * kor;
                T += wk;
                if (z != null && (maxZ == null || Math.abs(z) > maxZ)) maxZ = Math.abs(z);
                w.push({ n: n, hits: h, e: E, z: z, wklad: wk });
            }
            w.sort(function (a, b) { return b.wklad - a.wklad || a.n - b.n; });
            return { wiersze: w, suma: T, maxZ: maxZ };
        },
        sumujLata: function (roczniki) {
            var main = {}, N = 0;
            roczniki.forEach(function (r) {
                N += r.losowan || 0;
                Object.keys(r.main || {}).forEach(function (n) { main[n] = { hits: (main[n] ? main[n].hits : 0) + (+r.main[n] || 0) }; });
            });
            if (A.pula == null || A.typuje == null || !N) return null;
            var w = A.licz(main, N, A.pula, A.typuje);
            return { losowan: N, T: w.suma, df: A.pula - 1, p_asympt: null, testy_powod: null,
                     pct_kalibrowany: null, max_z: w.maxZ, c95: null, c99: null, poza: null, liczby: main };
        },
        wnioski: function (o, klucz, dane, zakres) {
            if (!o) return [A.en ? __pewniaki_inline_cfg[7] : __pewniaki_inline_cfg[8]];
            var f = A._f, p = [], testy = o.testy_powod != null;
            var std = o.T != null && o.df != null && o.df > 0 ? (o.T - o.df) / Math.sqrt(2 * o.df) : null;
            if (o.T != null && o.df != null && o.losowan != null)
                p.push(message('result', [A._tys(o.losowan), f(o.T, 3), o.df]));
            if (std != null) p.push(message('standardized', [f(std, 2)]));
            if (testy) p.push(A.en ? __pewniaki_inline_cfg[16] : __pewniaki_inline_cfg[17]);
            else if (o.p_asympt != null) p.push(message('pvalue', [f(o.p_asympt, 6)]));
            if (!testy && o.pct_kalibrowany != null) p.push(A.en ? __pewniaki_inline_cfg[20] + A._raw(o.pct_kalibrowany) + '%.' : __pewniaki_inline_cfg[21] + A._raw(o.pct_kalibrowany) + '%.');
            if (o.max_z != null) p.push(A.en ? __pewniaki_inline_cfg[22] + f(o.max_z, 3) + '.' : __pewniaki_inline_cfg[23] + f(o.max_z, 3) + '.');
            if (zakres && zakres.od != null) p.push(A.en ? __pewniaki_inline_cfg[24] + zakres.od + '–' + zakres.do + __pewniaki_inline_cfg[25] : __pewniaki_inline_cfg[26] + zakres.od + '–' + zakres.do + __pewniaki_inline_cfg[27]);
            return p.length ? p : [A.en ? __pewniaki_inline_cfg[28] : __pewniaki_inline_cfg[29]];
        },
        render: function (okno, klucz, dane, zakres) {
            var id = ++A._zadanie, q = A._q, info = q('[data-test-czestosci-tabela-info]');
            A._miary(okno);
            q('[data-test-czestosci-tabela] tbody').innerHTML = '';
            q('[data-test-czestosci-wklad]').textContent = '';
            if (!okno) { info.textContent = A.en ? __pewniaki_inline_cfg[30] : __pewniaki_inline_cfg[31]; return; }
            var m = dane.pula, kk = dane.typuje;
            if (m == null || kk == null || okno.losowan == null) { info.textContent = A.en ? __pewniaki_inline_cfg[32] : __pewniaki_inline_cfg[33]; return; }
            if (okno.liczby) {
                A._tabela(A.licz(okno.liczby, okno.losowan, m, kk));
                info.textContent = A.en ? __pewniaki_inline_cfg[34] : __pewniaki_inline_cfg[35];
                return;
            }
            info.textContent = A.en ? __pewniaki_inline_cfg[36] : __pewniaki_inline_cfg[37];
            A._czestosc(dane).then(function (d) {
                if (id !== A._zadanie) return;
                var w = d.okna[klucz];
                if (!w || w.powod != null || w.losowan !== okno.losowan || !w.liczby || typeof w.liczby !== 'object') {
                    info.textContent = A.en ? __pewniaki_inline_cfg[38] : __pewniaki_inline_cfg[39];
                    return;
                }
                A._tabela(A.licz(w.liczby, okno.losowan, m, kk));
                info.textContent = '';
            }).catch(function () {
                if (id !== A._zadanie) return;
                info.textContent = A.en ? __pewniaki_inline_cfg[40] : __pewniaki_inline_cfg[41];
            });
        },
        // Jeden Promise dla równoczesnych renderów; odrzucony znika, żeby dało się ponowić.
        _czestosc: function (dane) {
            if (!A._pobranie) {
                A._pobranie = fetch('/assets/json/db/' + A.kod + '/analizy/czestotliwosc.json?v=' + encodeURIComponent(A.wersja || ''))
                    .then(function (r) { if (!r.ok) throw new Error('HTTP'); return r.json(); })
                    .then(function (d) {
                        if (!d || typeof d.okna !== 'object' || d.gra !== dane.gra || d.pula !== dane.pula || d.typuje !== dane.typuje || d.policzono !== dane.policzono) throw new Error('niezgodne');
                        return d;
                    })
                    .catch(function (e) { A._pobranie = null; throw e; });
            }
            return A._pobranie;
        },
        _tabela: function (w) {
            var f = A._f, q = A._q, suma = w.suma;
            q('[data-test-czestosci-tabela] tbody').innerHTML = w.wiersze.slice(0, 10).map(function (r) {
                return __pewniaki_inline_cfg[42] + r.n + __pewniaki_inline_cfg[43] + A.kod + '">' + r.n + '</span></td><td class="liczbowa">' + A._tys(r.hits) + '</td><td class="liczbowa">' + f(r.e, 2)
                     + '</td><td class="liczbowa">' + f(r.z, 3) + '</td><td class="liczbowa">' + f(r.wklad, 3) + '</td><td class="liczbowa">'
                     + (suma > 0 ? f(r.wklad * 100 / suma, 1) + '%' : '—') + '</td></tr>';
            }).join('');
            var g = w.wiersze[0];
            q('[data-test-czestosci-wklad]').textContent = g && g.z != null
                ? (A.en ? __pewniaki_inline_cfg[44] + g.n + __pewniaki_inline_cfg[45] + A._tys(g.hits) + __pewniaki_inline_cfg[46] + f(g.e, 2) + ', z = ' + f(g.z, 3) + ', contribution ' + f(g.wklad, 3) + '.' : __pewniaki_inline_cfg[47] + g.n + ': ' + A._tys(g.hits) + __pewniaki_inline_cfg[48] + f(g.e, 2) + ', z = ' + f(g.z, 3) + __pewniaki_inline_cfg[49] + f(g.wklad, 3) + '.')
                : (A.en ? __pewniaki_inline_cfg[50] : __pewniaki_inline_cfg[51]);
        },
        _miary: function (o) {
            var q = A._q, f = A._f, testy = !!(o && o.testy_powod != null);
            var std = o && o.T != null && o.df != null && o.df > 0 ? (o.T - o.df) / Math.sqrt(2 * o.df) : null;
            var p = o && !testy ? o.p_asympt : null;
            q('[data-test-czestosci-n]').textContent = o && o.losowan != null ? A._tys(o.losowan) : '—';
            q('[data-a7-value="T"]').textContent = o && o.T != null ? f(o.T, 3) : '—';
            q('[data-a7-value="df"]').textContent = o && o.df != null ? String(o.df) : '—';
            q('[data-test-czestosci-std]').textContent = f(std, 2);
            q('[data-a7-value="p_asympt"]').textContent = p != null ? f(p, 6) : '—';
            q('[data-test-czestosci-p-uwaga]').hidden = !(p === 0);
            q('[data-test-czestosci-testy]').hidden = !testy;
            q('[data-test-czestosci-pct]').textContent = o && !testy && o.pct_kalibrowany != null ? A._raw(o.pct_kalibrowany) + '%' : '—';
            q('[data-test-czestosci-c95]').textContent = o && !testy && o.c95 != null ? A._raw(o.c95) : '—';
            q('[data-test-czestosci-c99]').textContent = o && !testy && o.c99 != null ? A._raw(o.c99) : '—';
            q('[data-test-czestosci-maxz]').textContent = o && o.max_z != null ? f(o.max_z, 3) : '—';
        },
        _q: function (s) { return document.querySelector(s); },
        _f: function (v, d) { var s = v == null || isNaN(v) ? '—' : Number(v).toFixed(d); return A.en ? s : s.replace('.', ','); },
        _raw: function (v) { var s = v == null ? '—' : String(v); return A.en ? s : s.replace('.', ','); },
        _tys: function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    };
    window.PEWNIAKI_ANALIZA = A;
})();
})();
